import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "gridlistadocumentos" }
const _hoisted_2 = { class: "table table-hover" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", { class: "mith" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Fecha"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Autorización"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Destinatario"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite der" }, "Valor")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { style: {"cursor":"pointer"} }
const _hoisted_8 = { class: "t izq bold" }
const _hoisted_9 = { class: "t izq bold" }
const _hoisted_10 = { class: "bold" }
const _hoisted_11 = { class: "bold der blue" }
const _hoisted_12 = {
  key: 0,
  class: "noRegist"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "bold izq bold" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "bold der blue" }, null, -1)
const _hoisted_17 = { class: "bold der blue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      (this.totales.documentos)
        ? (_openBlock(), _createElementBlock("thead", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.documentos, (documento, index) => {
        return (_openBlock(), _createElementBlock("tbody", {
          key: index,
          onClick: ($event: any) => (this.$router.push(`/documentosrec/${documento._id}`))
        }, [
          _createElementVNode("tr", _hoisted_7, [
            _createElementVNode("td", _hoisted_8, _toDisplayString($options.formatDate(documento.fechaProceso)), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(documento.autorizacion), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(documento.descCliente), 1),
            _createElementVNode("td", _hoisted_11, _toDisplayString($options.formatNumber(documento.reclamacion)), 1)
          ])
        ], 8, _hoisted_6))
      }), 128)),
      _createElementVNode("tbody", null, [
        (!this.totales.documentos)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_12, " No se encontraron registros para el médico seleccionado. "))
          : _createCommentVNode("", true),
        (this.totales.documentos)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
              _createElementVNode("td", _hoisted_14, " Total: " + _toDisplayString($options.formatNumber2(this.totales.documentos)), 1),
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("td", _hoisted_17, _toDisplayString($options.formatNumber(this.totales.reclamacion)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}